import { render, staticRenderFns } from "./SetAttributes.vue?vue&type=template&id=1863374d&scoped=true&"
import script from "./SetAttributes.vue?vue&type=script&lang=js&"
export * from "./SetAttributes.vue?vue&type=script&lang=js&"
import style0 from "./SetAttributes.vue?vue&type=style&index=0&id=1863374d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863374d",
  null
  
)

export default component.exports